

<template>
	<div class="nav-desktop">
		<transition name="fade">
			<component v-if="current.parent" is="BackButton"></component>
		</transition>
		<transition-group
			v-on:enter="navEnter" 
			v-on:leave="navLeave"
			v-bind:css="false">
			<component is="BigButton" :node="child" :index="index" :key="child.url" v-for="(child, index) in menue" :link="child.url">
				{{ child.name }}
			</component>
		</transition-group>
	</div>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'

import { gsap, TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Expo } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin);

export default {
	store,
	props: ['current', 'menue'],
	data: () => {
		return {
			prevMenue: [],
		}
	},
	computed: {
		...mapState('globals', ['app']),
		...mapState('settings', ['presets']),
	},

	watch: {
		menue( newVal, oldVal ) {
			this.prevMenue = oldVal || [];
		},
	},

	mounted() {
		
	},

	methods: {
		/**
		 * 	Animationen für Ein/Ausblenden der Navigation
		 * 	bei Wechsel der Levels.
		 * 
		 */
		navEnter(el, done) {
			TweenMax.fromTo(el, 0.5, {
				alpha: 0
			}, {
				alpha: 1,
				delay: (0.5 + this.prevMenue.length * 0.1) + el.dataset.index * 0.1,
				ease: Power4.easeOut,
				onComplete: done
			});
		},
		navLeave(el, done) {
			TweenMax.fromTo(el, 0.5, {
				alpha: 1,
			}, {
				alpha: 0,
				delay: (this.prevMenue.length - el.dataset.index) * 0.1,
				ease: Power4.easeOut
			});
			setTimeout( done, (0.5 + this.prevMenue.length * 0.1) * 1000 );
		},
	}

}
</script>

<style scoped lang="scss">
	
</style>
